/** Matches weplace `QUICK_BOOK_NO_FREE_WORKPLACE` on quick-book 409 responses. */
export const QUICK_BOOK_NO_FREE_WORKPLACE = "NO_FREE_WORKPLACE";

/** True when quick book refused because the chosen office has no free workplace. */
export function isQuickBookNoFreeWorkplaceError(error: unknown): boolean {
  if (typeof error !== "object" || error == null || !("response" in error)) {
    return false;
  }

  const message = (error as { response?: { data?: { message?: unknown } } }).response?.data
    ?.message;
  return message === QUICK_BOOK_NO_FREE_WORKPLACE;
}
